<template>
  <b-card class="profile-locomotion">
    <profile-form v-if="item" :user="item" :loading="loading" @submit="saveProfile">
      <template v-if="hasAddressChanged">
        <b-alert variant="danger" show class="address-change-warning">
          {{ $t("views.profile.locomotion.address_change_warning") }}
        </b-alert>
      </template>

      <template v-else-if="hasUnvalidatedCommunities">
        <b-alert variant="secondary" show class="community-proofs-missing-warning">
          <div class="d-flex align-items-center">
            <span>
              <b-badge href="#" class="ml-3 mr-3" pill variant="warning">!</b-badge>
            </span>

            <span class="flex-grow-1">
              {{ $t("views.profile.locomotion.community_proofs_missing_warning") }}
            </span>

            <b-button to="/profile/communities">{{
              $t("views.profile.locomotion.communities_link")
            }}</b-button>
          </div>
        </b-alert>
      </template>
    </profile-form>
  </b-card>
</template>

<script>
import ProfileForm from "@/components/Profile/ProfileForm.vue";
import { put } from "@/requests/server";

export default {
  name: "ProfileLocomotion",
  components: { ProfileForm },
  data() {
    return {
      item: { ...this.$store.state.user },
      initialItem: { ...this.$store.state.user },
      loading: false,
    };
  },
  computed: {
    hasAddressChanged() {
      return this.item.address !== this.initialItem.address;
    },
    hasUnvalidatedCommunities() {
      return this.$store.state.user?.user_communities.some(
        (uc) => uc.status !== "approved" && uc.proof_state !== "valid"
      );
    },
  },
  methods: {
    async saveProfile() {
      this.loading = true;
      try {
        const { data: item } = await put(`/users/${this.item.id}`, this.item, {
          notifications: {
            action: this.$t("views.profile.locomotion.actions.update_profile"),
            onSuccess: true,
          },
        });
        this.$store.commit("user", item);
        this.item = { ...item };
        this.initialItem = { ...item };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.profile-locomotion {
  margin-bottom: 3em;
  .community-proofs-missing-warning,
  .address-change-warning {
    margin-top: 20px;
  }

  .community-proofs-missing-warning {
    padding-left: 0;

    a.badge.badge-warning {
      &:hover,
      &:active,
      &:focus {
        color: #7e4c02;
        background-color: #fff3d2;
        box-shadow: none;
        cursor: default;
      }
    }
  }
}
</style>
